import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class ElemiValaszListItemDto extends IdentifiableDto {
	constructor() {
		super();
        /** @type {string} */
		this.szam = null;
        /** @type {string} */
        this.szoveg = null;
	}

	/**
	 * @Parameter {string} szam
     * @Parameter {string} szoveg
	 */
	setup(props) {
		super.setup(props);
		this.szam = props.szam;
        this.szoveg = props.szoveg;
		return this;
	}
}

export default ElemiValaszListItemDto;
